/* global $ */

// This is a wrapper around whatever service we have available for AJAX requests.
// The current website has JQuery loaded, so we can use that, but if we port this somewhere else we should use axios
export default {
  install(app) {
    this.app = app;
    app.config.globalProperties.$ajax = this;
    this.csrfToken = null;
  },
  get(url, data={}, enableCsrf=false) {
    return this.ajax(url, 'GET', data, enableCsrf);
  },
  post(url, data={}, enableCsrf=false) {
    return this.ajax(url, 'POST', data, enableCsrf);
  },
  ajax(url, method, data={}, enableCsrf=false) {
    const headers = {};
    if (enableCsrf) {
      headers['X-CSRFTOKEN'] = this.csrfToken ? this.csrfToken : $.cookie('csrftoken');
    }
    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        type: method,
        dataType: 'json',
        data: data,
        headers: headers,
        success: resolve,
        error: reject
      });
    });
  },
  setCsrfToken(csrfToken) {
    this.csrfToken = csrfToken;
  }
}